"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const defaultProps = {
    active: false,
    disabled: false,
    block: false,
};
const Button = ({ className, block, variant = "primary", size = "md", disabled = false, active, title = '', ...props }) => {
    const sizes = {
        sm: 'px-2.5 py-1.5 text-xs',
        md: 'px-4 py-2 text-sm',
        lg: '',
    };
    const variants = {
        primary: 'border border-transparent text-white bg-primary-500 hover:bg-primary-600 focus:ring-2 focus:ring-offset-2 focus:ring-primary-500',
        secondary: 'border border-transparent text-primary-600 bg-secondary-100 hover:bg-secondary-200',
        white: 'border border-gray-300 text-gray-700 bg-white hover:bg-gray-50',
        red: 'border border-transparent text-white bg-red-600 hover:bg-red-700'
    };
    const classes = (0, classnames_1.default)(className, 'inline-flex items-center font-medium rounded-md shadow-sm focus:outline-none', active && 'active', block && 'w-full justify-center', sizes[size], variants[variant], disabled && 'opacity-50 cursor-not-allowed');
    return (react_1.default.createElement("button", { ...props, title: title, className: classes, disabled: disabled }));
};
Button.defaultProps = defaultProps;
exports.default = Button;
